import { useQuery } from '@tanstack/react-query'
import { Badge, Card, CardBody, CardHeader, DataTable, type Column } from '@akillidernek/ui'
import { api } from '../api'

type Failure = {
  id: string
  function: string
  error_type: string
  error_message: string
  tries: number
  failed_at: string
}

const columns: Column<Failure>[] = [
  {
    key: 'fn',
    header: 'İş',
    cell: (row) => <code className="text-xs">{row.function}</code>,
    value: (row) => row.function,
  },
  { key: 'error', header: 'Hata', cell: (row) => row.error_type, value: (row) => row.error_type },
  {
    key: 'message',
    header: 'Mesaj',
    cell: (row) => <span className="text-xs">{row.error_message}</span>,
    value: (row) => row.error_message,
  },
  {
    key: 'tries',
    header: 'Deneme',
    align: 'right',
    cell: (row) => row.tries,
    value: (row) => row.tries,
  },
  {
    key: 'at',
    header: 'Zaman',
    align: 'right',
    cell: (row) => new Date(row.failed_at).toLocaleString('tr'),
    value: (row) => row.failed_at,
  },
]

/** Kuyruk sağlığı ve ölü mektup kuyruğu (YES-76). */
export function Isler() {
  const { data: health } = useQuery({
    queryKey: ['platform', 'jobs', 'health'],
    refetchInterval: 15_000,
    queryFn: async () => {
      const { data } = await api.GET('/api/v1/platform/jobs/health')
      return data
    },
  })

  const { data: failures } = useQuery({
    queryKey: ['platform', 'jobs', 'failures'],
    queryFn: async () => {
      const { data } = await api.GET('/api/v1/platform/jobs/failures')
      return (data ?? []) as Failure[]
    },
  })

  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-lg font-semibold">Arka plan işleri</h1>

      <Card>
        <CardHeader title="Kuyruk" description="Her 15 saniyede bir yenilenir." />
        <CardBody className="flex gap-6 text-sm">
          <span>
            Kuyrukta <strong className="tabular-nums">{health?.queued ?? 0}</strong>
          </span>
          <span>
            İşlenen <strong className="tabular-nums">{health?.in_progress ?? 0}</strong>
          </span>
          <span className="flex items-center gap-2">
            Çözülmemiş hata
            <Badge tone={health?.unresolved_failures ? 'danger' : 'success'}>
              {health?.unresolved_failures ?? 0}
            </Badge>
          </span>
        </CardBody>
      </Card>

      <DataTable
        rows={failures ?? []}
        columns={columns}
        rowKey={(row) => row.id}
        searchPlaceholder="İş ara…"
        emptyTitle="Başarısız iş yok"
        emptyDescription="Denemeleri tükenen bir iş olsaydı burada görünürdü."
      />
    </div>
  )
}
